import React,{useState,useEffect}from 'react'
import { Table,Space,Modal,message,Flex} from 'antd';
import { useGwGoodsTypeSubDelMutation, useGwGoodsTypeSubListQuery } from '../../store/ReactWebSiteApi';
import {nanoid} from 'nanoid'
import SonTypeEdit from './SonTypeEdit';
import SonTypeAdd from './SonTypeAdd';
function SonTypeList(props) {
    const {confirm} = Modal; 
    const [submitDel] = useGwGoodsTypeSubDelMutation()
    const {data,isSuccess} = useGwGoodsTypeSubListQuery({eowgt_id:props.eowgt_id},{refetchOnMountOrArgChange:1})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(nanoid());
                
                const newArr = data.Result.map(item => {
                    const {eowgts_id:key,eowgts_name,eowgts_content,eowgts_uname,eowgts_ctime,eowgts_update_ctime,eowgts_update_uname,goods_num,eowgts_serial_number} = item;
                    return item = {key,eowgts_name,eowgts_content,eowgts_uname,eowgts_ctime,eowgts_update_ctime,eowgts_update_uname,goods_num,eowgts_serial_number}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eowgts_serial_number;
                    let bTimeString = b.eowgts_serial_number;
                    return +aTimeString - +bTimeString;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'eowgts_serial_number',
            title: '序号',
            dataIndex: 'eowgts_serial_number'
        },
              
        {
            key: 'tag',
            title: '企业类型名称',
            dataIndex: 'eowgts_name',
        },           
        {
            key: 'goods_num',
            title: '商品数量',
            dataIndex: 'goods_num',
        },       
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },     
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.eowgts_ctime + record.eowgts_uname}</div>
                    <div>修改时间：</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space direction='vertical'>                        
                        <SonTypeEdit
                            eowgts_id={record.key}
                            eowgt_id={props.eowgt_id}
                        />
                        {record.goods_num==='0' && <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({eowgts_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
                    </Space>
                </>
            }
        },
    ]
    const [open, setOpen] = useState(false);
    return (
        <> 
            <a onClick={() => {setOpen(true)}}>子类型</a>
            <Modal
                open={open}
                title='子类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                footer={null}
                width={1000}
            >
                <Flex justify='end'>
                    <SonTypeAdd eowgt_id={props.eowgt_id} />
                </Flex>   
                <Table columns={columns} style={{marginTop:'20px'}} dataSource={list}></Table> 
            </Modal>
        </>
    )
}

export default SonTypeList